export type LeagueInfoKey = 'name' | 'public' | 'maxPlayers'

export type LeagueInfoEntry = {
    title: string;
    body: string;
}

// Shown at the top of the "Crear Liga Fantasy" screen. Many users create a league
// expecting to compete against every Futyclub user, so we spell out what creating
// a league actually does and point them to the public leagues instead.
export const CREATE_LEAGUE_INTRO: { title: string; paragraphs: string[] } = {
  title: 'Vas a crear tu propia liga',
  paragraphs: [
    'Se creará una única liga en la que, de momento, serás el único participante. NO es una competición contra todos los usuarios de Futyclub.',
    'Cuando la liga esté creada, invita a tus amigos para que se unan y podáis competir entre vosotros.',
    '¿Prefieres jugar ya con otra gente? Vuelve atrás y usa el botón "Unirse" para entrar en una liga pública.',
  ],
};

export const LEAGUE_INFO_CONTENT: Record<LeagueInfoKey, LeagueInfoEntry> = {
  name: {
    title: 'Nombre de la liga',
    body: 'Nombre visible para otros usuarios (búsqueda/identificación de la liga).',
  },
  public: {
    title: 'Liga pública / privada',
    body:
      'Si es pública, cualquier usuario puede unirse. Si es privada, necesitarán un código que podrás obtener en la pestaña de configuración.',
  },
  maxPlayers: {
    title: 'Máx. Jugadores Mercado',
    body:
      'Número máximo de jugadores que Futyclub sacará cada día a la venta para que los miembros puedan ficharlos.',
  },
};
